import React from 'react';
import { Avatar as AvatarBase } from '@rneui/themed';
export const Avatar = ({ user }) => {
    return (React.createElement(AvatarBase, { containerStyle: { alignSelf: 'flex-start' }, rounded: true, title: user.picture ? undefined : user.name ? user.name[0] : '', source: user.picture ? { uri: user.picture } : undefined }));
};
//# sourceMappingURL=Avatar.js.map